<div class="dpSheet">
  <div class="dpSheet__card">
    <app-driveplus-card
      [tiers]="data.tiers"
      [allBenefits]="data.allBenefits"
      [selectedCode]="selectedCode"
      [originalRoadTaxPrice]="data.originalRoadTaxPrice"
      [protectionPlanWording]="data.protectionPlanWording"
      [selected]="true"
      (tierChange)="onTierChange($event)"
    ></app-driveplus-card>
  </div>

  <div class="dpSheet__actions">
    <mat-checkbox class="dpSheet__confirm" [(ngModel)]="confirmed">
      {{ "plans.motorMembership.evpConfirmation" | translate }}
    </mat-checkbox>

    <button
      mat-flat-button
      color="primary"
      class="dpSheet__cta"
      [disabled]="!confirmed"
      (click)="confirm()"
    >
      {{
        "plans.motorMembership.confirmCta"
          | translate : { amount: (confirmPrice | number : "1.2-2") }
      }}
    </button>

    <button
      mat-stroked-button
      color="primary"
      class="dpSheet__decline"
      (click)="decline()"
    >
      {{ "plans.motorMembership.declineCta" | translate }}
    </button>
  </div>
</div>
